import { inject, Injectable } from '@angular/core';
import { ApiService, ConfigService } from '@ps-gui/shared-core';
import { ClaimsTerminalConfig } from '@ps-gui/claims-terminal-shared';
import { Observable } from 'rxjs';
import { BehandlerListEntry } from '../../pages/erfassung-behandler-page/components/model/behandler-list-entry.interface';

@Injectable({ providedIn: 'root' })
export class PsServerApiService extends ApiService {
  private readonly configService = inject(ConfigService<ClaimsTerminalConfig>);

  protected override get baseUrl(): string {
    return this.configService.config.psServerUrl;
  }

  getBehandlersByAuftragId(auftragId: string): Observable<BehandlerListEntry[]> {
    return this.get(`api/v2/medizinische-falldaten/behandler/auftrag/${auftragId}`);
  }

  getBehandlersByLegacyAuftragId(legacyAuftragId: string): Observable<BehandlerListEntry[]> {
    return this.get(`api/v2/medizinische-falldaten/behandler/legacyauftrag/${legacyAuftragId}`);
  }
}
